const dayStartChoicesRo = [
  {
    label: "Cu o plimbare liniștită de dimineață pe lângă mare.",
    value: 'With a peaceful morning walk by the sea.{"Blue":"3","Violet":"2"}',
  },

  {
    label: "Cu o antrenament activ.",
    value: 'With an active workout.{"Red":"3","Yellow":"2"}',
  },

  {
    label: "Cu o ceașcă caldă de cafea într-un colț confortabil.",
    value:
      'With a warm cup of coffee in a cozy corner.{"Brown":"3","Green":"2"}',
  },

  {
    label: "Cu un moment liniștit de meditație într-un spațiu minimalist.",
    value:
      'With a quiet moment of meditation in a minimalist space.{"Gray":"3","Black":"2"}',
  },
];

export default dayStartChoicesRo;
